import { Link, Stack, Typography, styled, useTheme } from '@mui/material'
import { useObservableEagerState } from 'observable-hooks'
import { useCallback } from 'react'

import { useSessionService } from '@salsita-ai/platform-project-sdk/react'
import { useResponsive } from '@salsita-ai/platform-project-sdk/ui'

const TopLine = styled(Typography)(({ theme }) => ({
  paddingInlineEnd: theme.spacing(2),
}))

const BottomLine = styled(Typography)(({ theme }) => ({
  position: 'relative',
  paddingInlineStart: theme.spacing(1),
  transform: `translateX(-${theme.spacing(1)})`,

  '&::before': {
    content: '""',
    width: '1px',
    height: '100%',
    background: theme.palette.text.secondary,
    position: 'absolute',
    top: 0,
    left: 0,
  },
}))

const Container = styled(Stack)(({ theme }) => ({
  padding: `${theme.spacing(1)} ${theme.spacing(2)}`,
  backgroundColor: theme.palette.background.paper,
}))

const FooterLink = styled(Link)({
  cursor: 'pointer',
  whiteSpace: 'nowrap',
})

const AdminLink = () => {
  const theme = useTheme()

  const handleClick = useCallback(() => {
    window.location.href = '/admin.html'
  }, [])

  return (
    <FooterLink title="Admin" target="_blank" onClick={handleClick}>
      <Typography variant="caption" color={theme.palette.text.secondary}>
        Admin
      </Typography>
    </FooterLink>
  )
}

// Copied form Davcor RiteRails configurator
export const ConfiguratorFooter = () => {
  const theme = useTheme()
  const { isPhone } = useResponsive()
  const sessionService = useSessionService()
  const session = useObservableEagerState(sessionService.session$)

  const handleLogout = useCallback(() => {
    sessionService.clearSession()
  }, [sessionService])

  const handleLogin = useCallback(() => {
    location.href = phoenix.runtimeConfig.SERVER_URL + `/deployments/${phoenix.runtimeConfig.DEPLOYMENT_ID}/auth`
  }, [])

  return (
    <Container
      direction="row"
      justifyContent="space-between"
      alignItems="center"
      sx={{ height: 35, marginTop: 'auto' }}
    >
      <Stack direction="row" flexWrap="wrap" overflow="hidden">
        <TopLine variant="caption" color={theme.palette.text.secondary}>
          John Michael
        </TopLine>
        <BottomLine variant="caption" color={theme.palette.text.secondary}>
          803-385-0741
        </BottomLine>
      </Stack>
      <Stack direction="row" gap={3} alignItems="center" sx={{ flexWrap: isPhone ? 'wrap' : 'nowrap' }}>
        {(session.sessionPayload?.role === 'admin' || session.sessionPayload?.role === 'superadmin') && <AdminLink />}

        {session.sessionPayload?.role === 'anonymous' ? (
          <FooterLink title="Login" target="_blank" onClick={handleLogin}>
            <Typography variant="caption" color={theme.palette.text.secondary}>
              Login
            </Typography>
          </FooterLink>
        ) : (
          <FooterLink title="Logout" target="_blank" onClick={handleLogout}>
            <Typography variant="caption" color={theme.palette.text.secondary}>
              Logout
            </Typography>
          </FooterLink>
        )}
      </Stack>
    </Container>
  )
}
